import type { FC } from "react"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

import styles from "./main-stat.module.scss"

export type MainStatData = {
  label: string
  value?: number | string
  icon?: FC<{ h: string; w: string; colored: boolean }>
}

type MainStatProps = MainStatData & {
  showRightBorder: boolean
}

export function MainStat({ label, value, icon: Icon, showRightBorder }: MainStatProps) {
  const { isMobile } = useTailwindBreakpoints()

  return (
    <>
      <Box className="items-center justify-between gap-1.5 lg:gap-0.5 lg:gap">
        <div className="w-[16px] h-[16px] lg:w-[52px] lg:h-[52px] flex items-center justify-center">
          {Icon ? (
            <Icon h={isMobile ? "1.6rem" : "2.5rem"} w={isMobile ? "1.6rem" : "2.5rem"} colored />
          ) : (
            typeof value !== "undefined" && (
              <Text weight="bold" size={isMobile ? "lg" : "h3"}>
                {value}
              </Text>
            )
          )}
        </div>
        <Text className="uppercase text-[#9188E2] text-sm lg:text-base" weight="bold">
          {label}
        </Text>
      </Box>
      {!isMobile && showRightBorder && <div className={`${styles["main-stat-border"]} w-0.5`} />}
    </>
  )
}
